const FromArr = [{
	title: "年度：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 52,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "月度：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 100,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 50,
	options: [{
		value: '1月',
		key: 1
	}, {
		value: '2月',
		key: 2
	}, {
		value: '3月',
		key: 3
	}, {
		value: '4月',
		key: 4
	}, {
		value: '5月',
		key: 5
	}, {
		value: '6月',
		key: 6
	}, {
		value: '7月',
		key: 7
	}, {
		value: '8月',
		key: 8
	}, {
		value: '9月',
		key: 9
	}, {
		value: '10月',
		key: 10
	}, {
		value: '11月',
		key: 11
	}, {
		value: '12月',
		key: 12
	}]
}]
export default FromArr;
